var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$isBotAgent())?_c('div',[_vm._t("default")],2):(_vm.renderLazyComp)?_c('v-lazy',{model:{value:(_vm.loaded),callback:function ($$v) {_vm.loaded=$$v},expression:"loaded"}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }